import { schemeCategory10, schemeObservable10 } from 'd3';

export const colorscheme = [...schemeCategory10, ...schemeObservable10, '#000000'];

export const COLOR_TONE_GROUPS: Record<string, string[]> = {
  blue: ['#1f77b4', '#4269d0', '#97bbf5', '#17becf'],
  orange: ['#ff7f0e', '#efb118'],
  red: ['#d62728', '#ff725c'],
  green: ['#2ca02c', '#3ca951', '#6cc5b0', '#bcbd22'],
  purple: ['#9467bd', '#a463f2'],
  pink: ['#e377c2', '#ff8ab7'],
  brown: ['#8c564b', '#9c6b4e'],
  gray: ['#7f7f7f', '#9498a0']
};

export function excludeSimilarTones(colors: (string | undefined)[]): string[] {
  const excluded = new Set(
    colors
      .map((color) => color?.toLowerCase())
      .filter((normalized): normalized is string => !!normalized)
      .flatMap(
        (normalized) =>
          Object.values(COLOR_TONE_GROUPS).find((group) => group.includes(normalized)) ?? []
      )
  );

  return colorscheme.filter((color) => !excluded.has(color.toLowerCase()));
}
